<template>
    <div :class="phoneClass || 'login-container'">
        <div class="login-header">
            <index-header>
                <div class="slot-content">
                    {{$t('header.login')}}
                </div>
            </index-header>
        </div>
        <div class="login-content">
            <div class="content-form" @keyup.enter="login">
                <h2 class="title">{{$t('header.login')}}</h2>
                <div class="input-area">
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.email')}}</p>
                        <el-input v-model="loginForm.account" :placeholder="$t('loginPage.email')"></el-input>
                    </div>
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.password')}}</p>
                        <el-input v-model="loginForm.password" type="password" :placeholder="$t('loginPage.password')"></el-input>
                    </div>
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.verification_code')}}</p>
                        <div class="captcha-floor">
                            <el-input v-model="loginForm.captcha_code" :placeholder="$t('loginPage.verification_code')"></el-input>
                            <img class="captcha-image" :src="captchaImage" @click="getLoginCaptcha">
                        </div>
                    </div>
                </div>
                <el-button type="primary" class="login-button" @click="login">{{$t('header.login')}}</el-button>
                <el-dialog custom-class="email-login-dialog" :title="$t('loginPage.mfa_login_code')" :visible.sync="mfaLoginDialogVisible" width="450px" top="12vh" :close-on-click-modal="false" :append-to-body="true">
                    <div class="dialog email-code-dialog" @keyup.enter="checkLoginMfaCode">
                        <div class="dialog-form email-code-dialog-form">
                            <div class="form-item">
                                <template v-if="mfaCodeForm.need_bind">
                                    <div class="mfa-bind-area">
                                        <img class="mfa-qrcode" :src="mfaCodeForm.qr_code" v-if="mfaCodeForm.qr_code">
                                        <div class="mfa-secret">{{mfaCodeForm.secret}}</div>
                                    </div>
                                </template>
                                <div class="form-label">{{$t('loginPage.mfa_login_code_tips')}}</div>
                                <div class="form-value">
                                    <el-input v-model="mfaCodeForm.mfa_code" :placeholder="$t('loginPage.mfa_login_code_placeholder')"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-bottom email-code-dialog-bottom">
                        <el-button class="cancel" @click="cancelMfaCode">{{$t('message.cancel')}}</el-button>
                        <el-button type="primary" class="confirm" @click="checkLoginMfaCode">{{$t('message.determine')}}</el-button>
                    </div>
                </el-dialog>
                <div class="recent-account-area" v-if="recentAccountList.length">
                    <p class="recent-account-title">{{$t('loginPage.recent_login_account')}}</p>
                    <div class="recent-account-list">
                        <div class="recent-account-item" v-for="item in recentAccountList" :key="item.account">
                            <div class="recent-account-info" @click="switchRecentAccount(item)">
                                <p class="recent-account-name">{{ item.user_name || item.account }}</p>
                                <p class="recent-account-value">{{ item.account }}</p>
                            </div>
                            <div class="recent-account-action-group">
                                <el-button type="text" class="recent-account-switch" @click="switchRecentAccount(item)">{{ $t('header.switch_action') }}</el-button>
                                <el-button type="text" class="recent-account-delete" @click="removeRecentAccount(item.account)">{{ $t('header.delete_account') }}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="operation">
                    <p @click="goRegister(1)">{{$t('loginPage.create_new_account')}}</p>
                    <p style="margin-bottom: 5px" @click="goRegister(0)">{{$t('loginPage.forget_password')}}？</p>
                    <div class="operation-floor" v-if="false">
                        <el-button @click="goRegister(1)">{{$t('loginPage.oem_customer')}}1</el-button>
                        <el-button @click="goRegister(2)">{{$t('loginPage.afm_customer')}}2</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import IndexHeader from './layout/header'
import Core from "core/core";
import {refresh} from "core/winSize"
export default {
    data() {
        return {
	        phoneClass: '',
	        loginForm: {
                account: '',
                password: '',
                captcha_code: ''
            },
            recentAccountList: [],
            captchaToken: '',
            captchaImage: '',
            mfaLoginDialogVisible: false,
            mfaCodeForm: {
                login_verify_token: '',
                mfa_code: '',
                need_bind: false,
                qr_code: '',
                secret: ''
            },
        };
    },
    components: {
        IndexHeader
    },
    mounted(){
        console.log('query', this.$route.query);
    },
    created() {
	    refresh(this,'phoneClass-login');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-login');
		    },10)
	    };

	    // window.localStorage.clear();
        // if(!Core.Data.isGuest()) {
        //     this.$router.push('/home');
        // }

	    // this.errorCodedTest()
        this.initRecentAccountList()
        this.getLoginCaptcha()
    },
    computed: {
    },
    methods: {
        async errorCodedTest() {
            const codeFile = require('../../core/js/errorCodeMap.js')
            const arr = Object.keys(codeFile.errorCodeMap);
            for (const el of arr) {
                Core.Api.Test.errorCode(el)
                await this.wait(1000 * 5);
            }
        },
        async wait(time = 2500) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                }, time);
            });
        },
        login() {
            if (this.mfaLoginDialogVisible) {
                this.checkLoginMfaCode()
                return
            }
            let login = this.loginForm;
            Core.Api.User.loginByEmail(login.account,login.password,this.captchaToken,login.captcha_code)
            .then(res => {
                if (res.need_mfa_bind === 1) {
                    this.mfaCodeForm.login_verify_token = res.login_verify_token
                    this.mfaCodeForm.mfa_code = ''
                    this.mfaCodeForm.need_bind = true
                    this.mfaCodeForm.qr_code = res.qr_code
                    this.mfaCodeForm.secret = res.secret
                    this.mfaLoginDialogVisible = true
                    return
                }
                if (res.need_mfa_code === 1) {
                    this.mfaCodeForm.login_verify_token = res.login_verify_token
                    this.mfaCodeForm.mfa_code = ''
                    this.mfaCodeForm.need_bind = false
                    this.mfaCodeForm.qr_code = ''
                    this.mfaCodeForm.secret = ''
                    this.mfaLoginDialogVisible = true
                    return
                }
                // this.$message.success('登录成功');
                this.loginSuccess(res)
            }).catch(() => {
                this.getLoginCaptcha()
            })
        },
        checkLoginMfaCode() {
            if (!this.mfaCodeForm.mfa_code) {
                this.$message.error(this.$t('loginPage.mfa_login_code_placeholder'))
                return
            }
            Core.Api.User.checkLoginMfaCode(this.mfaCodeForm.login_verify_token,this.mfaCodeForm.mfa_code).then(res => {
                this.mfaLoginDialogVisible = false
                this.loginSuccess(res)
            })
        },
        cancelMfaCode() {
            this.mfaLoginDialogVisible = false
            this.mfaCodeForm.login_verify_token = ''
            this.mfaCodeForm.mfa_code = ''
            this.mfaCodeForm.need_bind = false
            this.mfaCodeForm.qr_code = ''
            this.mfaCodeForm.secret = ''
            this.getLoginCaptcha()
        },

        // 获取登录图片验证码
        getLoginCaptcha() {
            Core.Email.Common.loginCaptcha().then(res => {
                this.captchaToken = res.captcha_token;
                this.captchaImage = res.captcha_image;
                this.loginForm.captcha_code = '';
            })
        },

        loginSuccess(res) {
            let { user, token } = res;
            Core.Data.setToken(token);
            Core.Data.setUser(user);
            Core.Data.saveRecentAccount({
                account: this.loginForm.account,
                user_name: user.nickname || user.username || user.email || user.phone || '',
                role: user.role,
                avatar: user.avatar || '',
                token: token,
                user: user
            });
            this.initRecentAccountList();
            // role：2工厂
            user.role === 2 ? this.$router.push('/storage') : this.$router.push('/home');
            // user.role === 1 ? this.$router.push('/home') : user.role === 2 ? this.$router.push('/storage') : this.$router.push('/home');
        },
        initRecentAccountList() {
            this.recentAccountList = Core.Data.getRecentAccountList();
        },
        switchRecentAccount(item) {
            if (!item || !item.account) {
                return;
            }
            let result = Core.Data.switchRecentAccount(item.account);
            if (!result) {
                this.$message.warning(this.$t('header.account_session_expired'));
                return;
            }
            let user = Core.Data.getUser();
            user && user.role === 2 ? this.$router.push('/storage') : this.$router.push('/home');
        },
        removeRecentAccount(account) {
            Core.Data.removeRecentAccount(account);
            this.initRecentAccountList();
        },
        goRegister(i) {
            i ? this.$router.push(`/register?type=${i}`) : this.$router.push("/retrieve")
        }
    },


};
</script>

<style scoped lang="scss">
@import '../assets/style/mixin.scss';
.mfa-bind-area {
    text-align: center;
    .mfa-qrcode {
        width: 220px;
        height: 220px;
        margin-bottom: 10px;
    }
    .mfa-secret {
        margin-bottom: 12px;
        color: #363D42;
        font-size: 13px;
        word-break: break-all;
    }
}
.login-container {
    height: 100vh;
    width: 100%;
    background: #E5EBEF;
    // background-image: radial-gradient(ellipse farthest-corner at 50% 100%, #263B4E 0%, #1A2936 100%);
    position: relative;
    // padding-top: 1px;
    .login-header {
        .slot-content {
            border-left: 1px solid rgba($color: #000000, $alpha: .3);
            display: inline-block;
            vertical-align: middle;
            font-size: 20px;
            color: #99BEFF;
            
            line-height: 26px;
            padding-left: 20px;
            font-weight: 500;
        }
    }
    .login-content {
        position: relative;
        min-height: calc(100vh - 82px);
        background-color: #E5EBEF;
        padding-top: 34px;
        .content-form {
            width: 430px;
            position: relative;
            background-color: #ffffff;
            padding: 40px;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            .title {
                font-size: 24px;
                color: #363D42;
                line-height: 26px;
            }
            .input-area {
                margin-top: 30px;
                margin-bottom: 40px;
                .input-floor {
                    margin-bottom: 20px;
                    .key {
                        font-size: 14px;
                        color: #7A8799;
                        margin-bottom: 6px;;
                    }
                    .captcha-floor {
                        display: flex;
                        align-items: center;
                        .el-input {
                            flex: 1;
                        }
                        .captcha-image {
                            width: 120px;
                            height: 42px;
                            margin-left: 10px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .login-button {
                width: 100%;
                height: 46px;
                span {
                    font-size: 16px;
                }
                color: #FFFFFF;
            }
            .recent-account-area {
                margin-top: 20px;
                .recent-account-title {
                    font-size: 14px;
                    color: #7A8799;
                    margin-bottom: 10px;
                }
                .recent-account-list {
                    border: 1px solid #E5EBEF;
                    border-radius: 4px;
                    .recent-account-item {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 10px 12px;
                        border-bottom: 1px solid #E5EBEF;
                        &:last-child {
                            border-bottom: none;
                        }
                        .recent-account-info {
                            flex: 1;
                            cursor: pointer;
                        }
                        .recent-account-name {
                            font-size: 14px;
                            color: #363D42;
                            margin-bottom: 4px;
                        }
                        .recent-account-value {
                            font-size: 12px;
                            color: #7A8799;
                        }
                        .recent-account-action-group {
                            display: flex;
                            align-items: center;
                            margin-left: 12px;
                            flex-shrink: 0;
                        }
                        .recent-account-switch,
                        .recent-account-delete {
                            padding: 0;
                            font-size: 12px;
                        }
                        .recent-account-delete {
                            margin-left: 12px;
                        }
                    }
                }
            }
            .operation {
                margin-top: 25px;
                p {
                    margin-bottom: 14px;
                    text-align: center;
                    font-size: 14px;
                    color: #0F58D6;
                    font-weight: 500;
                    cursor: pointer;
                }
                .operation-floor {
                    .el-button {
                        span {
                            font-size: 14px;
                            color: #0F58D6;
                            line-height: 20px;
                            padding: 10px 19px;
                        }
                    }
                }
            }
        }
    }
}

</style>

<style lang="scss">

.login-container {
    height: 100vh;
    background: #E5EBEF;

    .login-header {
        .header-wrapper {
            padding: 10px 0;
        }
    }

    .login-content{
        min-height: calc(100vh - 82px);
        .content-form {
            top: 0;
        }

        .input-floor {
            .el-input {
                height: 46px;
                .el-input__inner {
                    height: 46px;;
                }
            }
        }
    }
    .operation-floor {
        .el-button {
            span {
                font-size: 14px;
                color: #0F58D6;
                line-height: 20px;
                padding: 4px 3px;
                display: inline-block;
            }
        }
    }
}
.phoneClass-login {
    .el-button {
        width: 100%;
    }
    .el-input__inner {
        height: 30px;
    }
}
.email-login-dialog.el-dialog {
    margin: 12vh auto 0 !important;
    max-width: calc(100vw - 32px);
    border-radius: 18px !important;
    overflow: hidden !important;
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.24);
    .el-dialog__header {
        padding: 20px 28px 16px;
        border-bottom: 1px solid #E8EEF6;
        background: linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
    }
    .el-dialog__title {
        font-size: 20px;
        color: #334155;
        font-weight: 600;
        line-height: 28px;
    }
    .el-dialog__headerbtn {
        top: 22px;
        right: 22px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        font-size: 20px;
        color: #B6C0CF;
    }
    .el-dialog__body {
        padding: 24px 28px 22px;
        background: linear-gradient(180deg, #F8FAFC 0%, #F3F7FC 100%);
    }
    .el-dialog__footer {
        display: none;
    }
    .email-code-dialog {
        padding: 0;
    }
    .email-code-dialog-form {
        padding: 20px;
        background: #FFFFFF;
        border: 1px solid #E7EEF8;
        border-radius: 14px;
        box-shadow: 0 10px 24px rgba(15, 88, 214, 0.06);
        .form-label {
            margin-bottom: 8px;
            font-size: 14px;
            line-height: 20px;
            color: #475569;
            font-weight: 500;
        }
        .form-value {
            width: 100%;
        }
    }
    .el-input__inner {
        height: 44px;
        line-height: 44px;
        border-radius: 10px;
        border-color: #D7E2F0;
        background: #F8FAFC;
        color: #1E293B;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }
    .el-input__inner:focus {
        border-color: #0F58D6;
        box-shadow: 0 0 0 3px rgba(15, 88, 214, 0.12);
        background: #FFFFFF;
    }
    .el-input__inner::placeholder {
        color: #A0AEC0;
    }
    .email-code-dialog-bottom {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 12px;
        margin-top: 18px;
        padding: 18px 20px 16px;
        box-sizing: border-box;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(232, 240, 252, 0.95) 100%);
        border: 1px solid #DCE7F6;
        border-radius: 16px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
        .el-button {
            min-width: 108px;
            height: 44px;
            border-radius: 14px;
            font-size: 14px;
            font-weight: 500;
            padding: 0 24px;
            transition: all 0.2s ease;
        }
        .cancel {
            border-color: #D7E2F0;
            color: #475569;
            background: #FFFFFF;
            margin-right: 0;
            box-shadow: 0 6px 14px rgba(148, 163, 184, 0.10);
        }
        .cancel:hover {
            border-color: #BFD2F3;
            color: #0F58D6;
            background: #F8FBFF;
            transform: translateY(-1px);
        }
        .confirm {
            margin: 0;
            box-shadow: 0 8px 18px rgba(15, 88, 214, 0.24);
            background: linear-gradient(135deg, #2A6DF6 0%, #0F58D6 100%);
            border-color: #0F58D6;
        }
        .confirm:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 24px rgba(15, 88, 214, 0.28);
        }
    }
    @media (max-width: 520px) {
        .el-dialog__header {
            padding: 18px 20px 14px;
        }
        .el-dialog__body {
            padding: 20px;
        }
        .email-code-dialog-form {
            padding: 16px;
        }
        .email-code-dialog-bottom {
            padding: 16px;
            .el-button {
                min-width: 0;
                flex: 1;
            }
        }
    }
}
.phoneClass-login {
    min-height: 100vh;
    background: #E5EBEF;
    .login-header {
        .slot-content {
            border-left: 1px solid rgba(0, 0, 0, 0.3);
            color:#99BEFF;
            padding-left: 0.2rem;
            font-size: 0.3rem;
            vertical-align: middle;
            font-weight: 500;
        }
    }
    .login-content {
        width: 100%;
        .content-form {
            width: 70%;
            margin: 30px auto;
            background: white;
            padding: 30px;
            h2 {
                font-size: 24px;
                color: #363D42;
                line-height: 26px;
            }

            .input-area {
                margin-top: 15px;
                margin-bottom: 15px;
                .input-floor{
                    margin-bottom: 20px;
                    p {
                        font-size: 14px;
                        color: #7A8799;
                        margin-bottom: 6px;
                    }
                    .el-input {

                        .el-input__inner {
                            height: 40px;
                        }
                    }
                    .captcha-floor {
                        display: flex;
                        align-items: center;
                        .el-input {
                            flex: 1;
                        }
                        .captcha-image {
                            width: 1.8rem;
                            height: 0.64rem;
                            margin-left: 0.12rem;
                            cursor: pointer;
                        }
                    }
                    .email-code-dialog {
                        .email-code-tips {
                            margin-bottom: 10px;
                            font-size: 14px;
                            color: #7A8799;
                        }
                    }
                }
            }
            .recent-account-area {
                margin-top: 15px;
                .recent-account-title {
                    font-size: 14px;
                    color: #7A8799;
                    margin-bottom: 10px;
                }
                .recent-account-list {
                    border: 1px solid #E5EBEF;
                    border-radius: 4px;
                    .recent-account-item {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 10px;
                        border-bottom: 1px solid #E5EBEF;
                        &:last-child {
                            border-bottom: none;
                        }
                        .recent-account-info {
                            flex: 1;
                        }
                        .recent-account-name {
                            font-size: 14px;
                            color: #363D42;
                            margin-bottom: 4px;
                        }
                        .recent-account-value {
                            font-size: 12px;
                            color: #7A8799;
                            word-break: break-all;
                        }
                        .recent-account-action-group {
                            display: flex;
                            align-items: center;
                            margin-left: 10px;
                            flex-shrink: 0;
                        }
                        .recent-account-switch,
                        .recent-account-delete {
                            padding: 0;
                            font-size: 12px;
                        }
                        .recent-account-delete {
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
        .operation {
            margin-top: 15px;
            text-align: center;
            font-size: 12px;
            color: #0F58D6;
            font-weight: 500;
            cursor: pointer;
            p {
                margin-bottom: 5px;
            }
        }
    }
}
</style>
